module.exports = __webpack_public_path__ + "static/media/img_top_gift.18e70b39.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@1x/img_top_gift.png
// module id = 783
// module chunks = 0